import { useEffect } from "react";
import AddJurisdictionForm from "../forms/AddJurisdictionForm";
import useGetData from "../../../CustomHooks/useAxios/useGetData";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import spin from "../../../assets/icons/spin.png";
import { HIER_SETUP, ADD_HIER } from "../apiEndpoints";
import usePostData from "../../../CustomHooks/useAxios/usePostData";
import MainPageLayout from "../../../layout/MainPageLayout";

const AddJurisdictionPage = () => {
  const { data, isLoaded, error, getData } = useGetData();
  const {
    executePost,
    loading,
    formError,
    setFormError,
    successResponse,
    setSuccessResponse,
  } = usePostData();

  useEffect(() => {
    getData(HIER_SETUP);
  }, [successResponse]);

  // execute post api
  const sendData = async (data, reset) => {
    // API calling
    executePost(data, ADD_HIER, reset);
  };

  return (
    <MainPageLayout headerConfig={{ title: "Add Jurisdiction" }}>
      {isLoaded && !error ? (
        <AddJurisdictionForm
          hierSetup={data}
          sendData={sendData}
          loading={loading}
          successResponse={successResponse}
          setSuccessResponse={setSuccessResponse}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};

export default AddJurisdictionPage;
